import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_FUNKTIONSBEREICH_ENTFERNEN_MULTI = '[VeranstaltungenModul] PostFunktionsbereichEntfernenMulti laden';
export const POST_FUNKTIONSBEREICH_ENTFERNEN_MULTI_AUSFUEHREN = '[VeranstaltungenModul] PostFunktionsbereichEntfernenMulti ausführen';
export const POST_FUNKTIONSBEREICH_ENTFERNEN_MULTI_ERFOLGREICH = '[VeranstaltungenModul] PostFunktionsbereichEntfernenMulti laden erfolgreich';
export const POST_FUNKTIONSBEREICH_ENTFERNEN_MULTI_FEHLER = '[VeranstaltungenModul] PostFunktionsbereichEntfernenMulti Ladefehler';
export const POST_FUNKTIONSBEREICH_ENTFERNEN_MULTI_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostFunktionsbereichEntfernenMulti nicht ausgeführt (evtl. Offline)';


export class PostFunktionsbereichEntfernenMultiAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ENTFERNEN_MULTI;
        constructor(public funktionsbereichEntfernenMultiRequest: api.FunktionsbereichEntfernenMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichEntfernenMultiAusfuehrenAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ENTFERNEN_MULTI_AUSFUEHREN;
        constructor(public funktionsbereichEntfernenMultiRequest: api.FunktionsbereichEntfernenMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichEntfernenMultiErfolgreichAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ENTFERNEN_MULTI_ERFOLGREICH;
        constructor(public payload: api.VeranstaltungIdentifier, public funktionsbereichEntfernenMultiRequest: api.FunktionsbereichEntfernenMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichEntfernenMultiFehlerAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ENTFERNEN_MULTI_FEHLER;
        constructor(public payload: any, public funktionsbereichEntfernenMultiRequest: api.FunktionsbereichEntfernenMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichEntfernenMultiNichtAusgefuehrtAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ENTFERNEN_MULTI_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandFunktionsbereichEntfernenMultiActions =
    PostFunktionsbereichEntfernenMultiAction
    | PostFunktionsbereichEntfernenMultiAusfuehrenAction
    | PostFunktionsbereichEntfernenMultiErfolgreichAction
    | PostFunktionsbereichEntfernenMultiFehlerAction
    | PostFunktionsbereichEntfernenMultiNichtAusgefuehrtAction
    ;
